module.exports = __webpack_public_path__ + "img/manda_005.414fa141.png";